import React from 'react'
import styled from 'styled-components'

function Scratch({src, backgroundColor}) {
  return (
    <Wrapper backgroundColor={backgroundColor}>
      <Content src={src} allowtransparency="true" width="485" height="402" scrolling="no" allowfullscreen></Content>
    </Wrapper>
  )
}

export default Scratch;

const Wrapper = styled.div`
    display:flex;
    justify-content:center;
    width:100%;
    background-color: ${props=> props.backgroundColor ? props.backgroundColor : 'var(--color-azul-oscuro)'};
    padding-bottom: 40px;
`;

const Content = styled.iframe`
    border:none;
    border-radius:10px;
`;